import React, { useEffect, useState } from 'react'
import { Box, styled } from '@mui/system'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import MuiPhoneNumber from 'material-ui-phone-number'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import Select from '@mui/material/Select'
import { Link } from 'react-router-dom'
import axios from 'axios'
import { ToastContainer } from 'react-toastify'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { Apis } from 'app/Apis/Apis'
import { AuthToken } from 'app/auth/AuthToken'
import Alert from '@mui/material/Alert'
import validator from 'validator'
import { StaticData } from 'app/utils/constant'

const Container = styled('div')(({ theme }) => ({
    margin: '30px',
    [theme.breakpoints.down('sm')]: {
        margin: '16px',
    },
    '& .breadcrumb': {
        marginBottom: '30px',
        [theme.breakpoints.down('sm')]: {
            marginBottom: '16px',
        },
    },
}))

const EditUser = () => {
    const [roledata, setRoledata] = useState()
    const [phoneNum, setPhoneNum] = useState()
    const [emailErr, setEmailErr] = useState()
    const [message, setMessage] = useState()
    const [alldata, setAllData] = useState({
        name: '',
        username: '',
        email: '',
        role: '',
        address: '',
    })

    const [searchParams] = useSearchParams()
    const roleId = searchParams.get('_id')
    const [imgdata, setImgdata] = useState()
    const imageUrl = imgdata?.name ? URL.createObjectURL(imgdata) : imgdata
    const navigate = useNavigate()
    const imgHandleChange = (e) => {
        setImgdata(e.target.files[0])
    }

    let config = {
        headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
    }

    const singleRole = () => {
        axios
            .get(`${Apis.getSingleRole}/${roleId}`, config)
            .then((res) => {
                setRoledata(res?.data?.data)
            })
            .catch((err) => {
                console.log('Error in single role', err)
            })
    }

    const setState = () => {
        setAllData({
            name: roledata?.name,
            username: roledata?.username,
            email: roledata?.email,
            role: roledata?.role,
            address: roledata?.address,
        })
        setImgdata(roledata?.image)
        setPhoneNum(roledata?.mobilenumber)
    }

    const handleChange = (e) => {
        setAllData({
            ...alldata,
            [e.target.name]: e.target.value,
        })
    }

    const validateEmail = (value) => {
        if (validator.isEmail(value)) {
            setEmailErr(true)
        } else {
            setEmailErr('Contains invalid characters!')
        }
    }

    useEffect(() => {
        singleRole()
    }, [])

    useEffect(() => {
        setState()
    }, [roledata])

    useEffect(() => {
        validateEmail(alldata.email || '')
    }, [alldata])

    const handleSubmit = () => {
        var formdata = new FormData()
        formdata.append('name', alldata.name)
        formdata.append('username', alldata.username)
        formdata.append('role', alldata.role)
        formdata.append('email', alldata.email)
        formdata.append('address', alldata.address)
        formdata.append('mobilenumber', phoneNum)
        formdata.append('_id', roleId)
        formdata.append('image', imgdata)

        if (
            !alldata.name ||
            !alldata.username ||
            !alldata.email ||
            !phoneNum ||
            !alldata.role ||
            !alldata.address
        ) {
            if (!alldata.name) {
                setMessage('Name is required !')
            } else {
                if (!alldata.username) {
                    setMessage('Username is required !')
                } else {
                    if (!alldata.email || emailErr != true) {
                        !alldata.email
                            ? setMessage('Email is required !')
                            : setMessage('Add valid email!')
                    } else {
                        if (!phoneNum) {
                            setMessage('Phone number is required !')
                        } else {
                            if (!alldata.role) {
                                setMessage('Role details is required !')
                            } else {
                                if (!alldata.address) {
                                    setMessage('Address is required !')
                                }
                            }
                        }
                    }
                }
            }
        } else {
            axios
                .put(`${Apis.editRole}`, formdata, config)
                .then((res) => {
                    setMessage([
                        res?.data?.message || 'Role added successfully',
                        res?.data?.code,
                    ])
                    setTimeout(() => {
                        navigate('/dashboard/rolemanagement')
                    }, 2000)
                })
                .catch((err) => {
                    console.log(
                        'Error in Edit user',
                        err?.response?.data?.message
                    )
                    setMessage(err?.response?.data?.message)
                })
        }

        setTimeout(() => {}, 2000)
    }

    const testData = () => {
        singleRole()
    }

    return (
        <Container>
            {message ? (
                <Alert
                    severity={message[1] === 200 ? 'success' : 'error'}
                    sx={{ position: 'fixed', width: '80%' }}
                >
                    {message.length === 2 ? message[0] : message}
                </Alert>
            ) : (
                ''
            )}
            <Link to={'/dashboard/rolemanagement'}>
                <Box sx={{ padding: '15px 0px' }}>
                    <ArrowBackIcon />
                </Box>
            </Link>

            <Box
                sx={{
                    borderBottom: 'solid',
                    borderColor: 'grey.200',
                    marginBottom: 5,
                    fontWeight: 500,
                    fontSize: 20,
                }}
            >
                Edit user
            </Box>
            <Box
                sx={{
                    borderBottom: 'solid',
                    borderColor: 'grey.200',
                    width: '110%',
                }}
            >
                <Box sx={{ display: 'flex', paddingBottom: 1 }}>
                    <Box sx={{ width: '30%' }} onClick={testData}>
                        Name
                    </Box>{' '}
                    <Box
                        sx={{
                            width: '70%',
                            display: 'flex',
                            justifyContent: 'flex-start',
                        }}
                    >
                        {' '}
                        <TextField
                            id="outlined-password-input"
                            label="Name"
                            type="text"
                            name="name"
                            value={alldata.name}
                            onChange={handleChange}
                            autoComplete="current-password"
                            sx={{ padding: 0, width: '30vh' }}
                        />{' '}
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', paddingBottom: 1 }}>
                    <Box sx={{ width: '30%' }}>Username</Box>{' '}
                    <Box
                        sx={{
                            width: '70%',
                            display: 'flex',

                            justifyContent: 'flex-start',
                        }}
                    >
                        {' '}
                        <TextField
                            id="outlined-password-input"
                            label="Username"
                            type="text"
                            value={alldata.username}
                            name="username"
                            onChange={handleChange}
                            sx={{ paddingBottom: 1, width: '30vh' }}
                            autoComplete="current-password"
                        />
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', paddingBottom: 1 }}>
                    <Box sx={{ width: '30%' }}>Email</Box>{' '}
                    <Box
                        sx={{
                            width: '70%',
                            display: 'flex',
                            justifyContent: 'flex-start',
                        }}
                    >
                        {' '}
                        <TextField
                            id="outlined-password-input"
                            label="Email"
                            sx={{ paddingBottom: 1, width: '30vh' }}
                            type="email"
                            name="email"
                            value={alldata.email}
                            onChange={handleChange}
                            // sx={{ paddingBottom: 1 }}
                            autoComplete="current-password"
                        />
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', paddingBottom: 1 }}>
                    <Box sx={{ width: '30%' }}>Phone number</Box>{' '}
                    <Box
                        sx={{
                            width: '70%',
                            display: 'flex',
                            justifyContent: 'flex-start',
                        }}
                    >
                        {' '}
                        <MuiPhoneNumber
                            label="Phone Number"
                            defaultCountry={'us'}
                            variant="outlined"
                            name="phone"
                            value={phoneNum}
                            sx={{ paddingBottom: 1, width: '30vh' }}
                            onChange={(e) => {
                                setPhoneNum(e)
                            }}
                        />
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', paddingBottom: 1 }}>
                    <Box sx={{ width: '30%' }}>Role</Box>{' '}
                    <Box
                        sx={{
                            width: '70%',
                            display: 'flex',
                            justifyContent: 'flex-start',
                        }}
                    >
                        {' '}
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Role"
                            type="text"
                            name="role"
                            value={alldata.role}
                            onChange={handleChange}
                            sx={{ paddingBottom: 1, width: '30vh' }}
                        >
                            <MenuItem value="superadmin">Super Admin</MenuItem>
                            <MenuItem value="admin">Admin</MenuItem>
                            <MenuItem value="doctor">Doctor</MenuItem>
                        </Select>
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', paddingBottom: 1 }}>
                    <Box sx={{ width: '30%' }}>Address</Box>{' '}
                    <Box
                        sx={{
                            width: '70%',
                            display: 'flex',
                            justifyContent: 'flex-start',
                        }}
                    >
                        {' '}
                        <TextField
                            id="outlined-password-input"
                            label="Address"
                            multiline
                            name="address"
                            value={alldata.address}
                            onChange={handleChange}
                            type="text"
                            sx={{ paddingBottom: 1, width: '50vw' }}
                            autoComplete="current-password"
                        />
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', paddingBottom: 1 }}>
                    <Box sx={{ width: '30%' }}>Profile image</Box>{' '}
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'start',
                            alignItems: 'center',
                            width: '50%',
                        }}
                    >
                        <img
                            src={imageUrl || imgdata}
                            alt=""
                            style={{
                                width: '75px',
                                height: '75px',
                                position: 'relative',
                                borderRadius: '50px',
                                left: '2%',
                            }}
                        />
                        <input
                            type="file"
                            id="avatarUpload"
                            style={{ display: 'none' }}
                            onChange={imgHandleChange}
                        />

                        <Box sx={{ marginLeft: 5 }}>
                            <Button variant="contained">
                                <label htmlFor="avatarUpload">
                                    Upload photo
                                </label>
                            </Button>{' '}
                        </Box>
                    </Box>
                </Box>
            </Box>
            <Button
                variant="contained"
                sx={{ marginTop: 3 }}
                onClick={handleSubmit}
            >
                Submit
            </Button>

            <ToastContainer />
        </Container>
    )
}

export default EditUser
